import DatabaseIcon from '@databases/icons/DatabaseIcon';
import {
  BasicDatabase,
  BrokenDatabase,
  ShallowDatabase,
} from '@databases/types/database';
import { formatDistance } from 'date-fns';
import React, { FunctionComponent } from 'react';

import {
  DatabaseOptionContainer,
  DatabaseOptionContentContainer,
  DatabaseOptionIcon,
  DatabaseOptionInfoContainer,
  DatabaseOptionTitle,
} from './databasePicker.styles';

type Option = ShallowDatabase | BasicDatabase | BrokenDatabase;

export interface DatabasePickerOptionProps {
  value: Option;
}

const DatabasePickerOption: FunctionComponent<DatabasePickerOptionProps> = ({
  value,
}) => {
  const getTimePassedString = (previousDate: string) => {
    const now = new Date();
    const previous = new Date(previousDate);

    return formatDistance(previous, now, { addSuffix: true });
  };

  return (
    <DatabaseOptionContainer>
      <DatabaseOptionIcon>
        <DatabaseIcon label="" />
      </DatabaseOptionIcon>
      <DatabaseOptionContentContainer>
        <DatabaseOptionTitle>{value.name}</DatabaseOptionTitle>
        <DatabaseOptionInfoContainer>
          <span>{value.space.name}</span>
          <span>
            {
              // Won't translate asterisk
              // eslint-disable-next-line formatjs/no-literal-string-in-jsx
            }
            •
          </span>
          <span>{getTimePassedString(value.lastUpdatedDate)}</span>
        </DatabaseOptionInfoContainer>
      </DatabaseOptionContentContainer>
    </DatabaseOptionContainer>
  );
};

export default DatabasePickerOption;
